import { render, staticRenderFns } from "./text_config.vue?vue&type=template&id=af45ef58&scoped=true&"
import script from "./text_config.vue?vue&type=script&lang=js&"
export * from "./text_config.vue?vue&type=script&lang=js&"
import style0 from "./text_config.vue?vue&type=style&index=0&id=af45ef58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af45ef58",
  null
  
)

export default component.exports